import ActivityDocumentPhoto from './ActivityDocumentPhoto'

export default ActivityDocumentPhoto
